import { render, staticRenderFns } from "./Sabrole.vue?vue&type=template&id=7138506e&scoped=true"
import script from "./Sabrole.vue?vue&type=script&lang=js"
export * from "./Sabrole.vue?vue&type=script&lang=js"
import style0 from "./Sabrole.vue?vue&type=style&index=0&id=7138506e&prod&lang=css"
import style1 from "./Sabrole.vue?vue&type=style&index=1&id=7138506e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7138506e",
  null
  
)

export default component.exports